import { connect } from 'react-redux';
import * as R from 'ramda';
import { loadingManagementApi } from 'feature/loading-management/loadingManagementApi';
import {
  createSupplierAuthorization,
  getAuthorizationBy,
  getLocation,
  getParams,
  getProduct,
  getSelectedProducts,
  getSupplier,
  setSubmittingBatch,
} from '../../store/createNewSupplierAuthSlice';
import Progress from './Progress';

const mapState = R.applySpec({
  authorizationBy: getAuthorizationBy,
  location: getLocation,
  params: getParams,
  product: getProduct,
  selectedProducts: getSelectedProducts,
  supplier: getSupplier,
});

const mapDispatch = {
  createSupplierAuthorization,
  refreshSupplierAuthorizationsListView: () =>
    loadingManagementApi.util.invalidateTags(['SupplierAuthorizationList']),
  setSubmittingBatch,
};

export default connect(mapState, mapDispatch)(Progress);
